export const debugPanelCss = "d14v3qq8";
export const debugPanelActionsCss = "d1q2pyot";
export const debugPanelStatusCss = "dk2b21e";
export const debugPanelCountdownOptionsCss = "d56o9le";

/** Hairline rule between panel sections. */
export const debugPanelSeparatorCss = "dcfr456";

require("./debugPanelStyles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./debugPanelStyles.ts");